import * as React from 'react';
import { TextField, type TextFieldProps, useTheme } from '@mui/material';
import { baseFieldSx } from './styles.ts';


export const Input = (props: Omit<TextFieldProps, 'variant'>) => {
  const { sx, ...rest } = props;
  const theme = useTheme();
  return (
    <TextField
      sx={baseFieldSx(theme, sx)}
      {...rest}
    />
  );
};

